import React from 'react';
import {Container,Row,Col} from "react-bootstrap"
// import BgImg from "../../images/home-update/sub-bg-image.png";
import {
    HomeUpdatedOneProcess,
    HomeUpdatedTwoProcess,
    HomeUpdatedThreeeProcess,
    HomeUpdatedFourProcess,
    HomeUpdatedFiveProcess,
    HomeUpdatedSixProcess,


} from "../../../app-constants";

function Process(props) {


    return (

        <section className="tekrevol__process p-100">
        <Container>
            <Row>

                <Col
                    xs={12}
                    md={12}
                    lg={12}
                    xl={12}
                    xxl={12}
                    className="mt-auto mb-auto">
                    <div className="example example-bottom" data-text="App Process">
                        <h2>App Development <br className="d-xl-block d-none" />Process</h2>
                    </div>
                </Col>

            </Row>
            <Row>
                <Col
                    xs={12}
                    md={6}
                    lg={6}
                    xl={4}
                    xxl={4}
                    className="mt-auto mb-auto"
                >
                   
                    <div className="serv-item h-100">
                        <div className="serv-inner tekrevol_gray_bg">
                            <div className="img">{HomeUpdatedOneProcess}</div>
                            <div className="title">Scope of Work</div>
                            <p>We define your project goals, milestones, deliverables, and to ensure clear and structured development.</p>
                        </div>
                    </div>
                            
                </Col>
                <Col
                    xs={12}
                    md={6}
                    lg={6}
                    xl={4}
                    xxl={4}
                    className="mt-auto mb-auto"
                >
                   
                    <div className="serv-item h-100">
                        <div className="serv-inner tekrevol_gray_bg">
                            <div className="img">{HomeUpdatedSixProcess}</div>
                            <div className="title">
                                UI/UX Design
                            </div>
                            <p>Our design team creates your app design and user journey based on your brand guidelines and industry trends.</p>
                        </div>
                    </div>
                            
                </Col>
                <Col
                    xs={12}
                    md={6}
                    lg={6}
                    xl={4}
                    xxl={4}
                    className="mt-auto mb-auto"
                >
                   
                    <div className="serv-item h-100">
                        <div className="serv-inner tekrevol_gray_bg">
                            <div className="img">{HomeUpdatedThreeeProcess}</div>
                            <div className="title">
                                Alpha Development
                            </div>
                            <p>The development team builds the core functionality of the app for initial testing and feedback.</p>
                        </div>
                    </div>
                            
                </Col>
                <Col
                    xs={12}
                    md={6}
                    lg={6}
                    xl={4}
                    xxl={4}
                    className="mt-auto mb-auto"
                >
                   
                    <div className="serv-item h-100">
                        <div className="serv-inner tekrevol_gray_bg">
                            <div className="img">{HomeUpdatedFourProcess}</div>
                            <div className="title">
                                Beta Development
                                </div>
                            <p>We develop the full-feature set of the app, including 3rd party integrations for broader feedback and testing.</p>
                        </div>
                    </div>
                            
                </Col>
                <Col
                    xs={12}
                    md={6}
                    lg={6}
                    xl={4}
                    xxl={4}
                    className="mt-auto mb-auto"
                >
                   
                    <div className="serv-item h-100">
                        <div className="serv-inner tekrevol_gray_bg">
                            <div className="img">{HomeUpdatedTwoProcess}</div>
                            <div className="title">
                                QA and UAT
                            </div>
                            <p>Conduct rigorous quality assurance an user-acceptance testing for functionality, experience, and performance.</p>
                        </div>
                    </div>
                            
                </Col>
                <Col
                    xs={12}
                    md={6}
                    lg={6}
                    xl={4}
                    xxl={4}
                    className="mt-auto mb-auto"
                >
                   
                    <div className="serv-item h-100">
                        <div className="serv-inner tekrevol_gray_bg">
                            <div className="img">{HomeUpdatedFiveProcess}</div>
                            <div className="title">
                                Deployment
                            </div>
                            <p>Launch the final version of the application on Google Play store or Apple’s app store.</p>
                        </div>
                    </div>
                            
                </Col>

            </Row>
        </Container>
    </section>


    );

}

export default Process;